import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, SpanStyled } from '../../Styled/Elements'
import { PrimaryHeading } from '../../Styled/CustomElements'
import { ClientHand } from '../../Styled/AllImages'
import { useTranslation } from 'react-i18next'
import { MainWrapper } from './Styled'
import ClientsSlider from './ClientsSlider'

const Clients = () => {
    const { t } = useTranslation();
    

    return (
        <MainWrapper className='section-common mainWrapper' id='clients'>
            <Container className='container-fluid'>
                <Row className='main-wrap'>
                    <Box className='mainHeading'>
                        <PrimaryHeading HlabelF={t("WhatOur")} HlabelS={t("ClientsSays")} customClass="text-center" />
                    </Box>
                    <SpanStyled size='15px' className='mb-4 text-center mainMainTxt'>
                        {t('cltText')}
                    </SpanStyled>
                    <Col md={12}>
                        <ClientsSlider />
                    </Col>
                    
                </Row>
                <img className='clientHand' src={ClientHand} alt="Hand"/>
            </Container>
        </MainWrapper>
    )
}

export default Clients
